import THEME from 'pobble-components/dist/theme'

const { COLORS } = THEME

const styles = {
  counter: {
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  },
  error: {
    color: COLORS.RED.NORMAL
  }
}

export default styles
